import * as stylex from '@stylexjs/stylex';
import _ from 'lodash';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { COMPARISON_OPERATORS_SYMBOLS } from '@/toolSelection/investigate.constants';
import { Select } from '@seeqdev/qomponents';

interface OperatorSelectIF {
  operators: any[];
  value: any;
  onChange: (entryCondition: any) => void;
  extraClassNames?: string;
  xstyle?: stylex.StyleXStyles;
  disabled?: boolean;
  inputGroup?: 'left' | 'right';
}

const OperatorsSelectUnwrapped = (props: OperatorSelectIF) => {
  const { operators, onChange, value, extraClassNames, xstyle, disabled, inputGroup } = props;
  const { t } = useTranslation();

  const operatorKeys = _.invert(COMPARISON_OPERATORS_SYMBOLS);
  const formattedOperators = _.map(operators, (operator) => ({
    text: operator,
    value: operator,
    label: (
      <>
        <span {...stylex.props(styles.operatorSymbol)} id={operator}>
          {operator}
        </span>
        <span {...stylex.props(styles.operatorDescription)}>
          {t(`VALUE_SEARCH.OPERATORS.${operatorKeys[operator]}`)}
        </span>
      </>
    ),
  }));

  const selectedValue = _.find(formattedOperators, { value });
  return (
    <Select
      extraClassNames={extraClassNames}
      xstyle={[styles.operatorSelect, xstyle]}
      menuPortalTarget={document.body}
      menuPlacement="auto"
      placeholder=""
      value={_.isUndefined(selectedValue) ? null : selectedValue}
      options={formattedOperators}
      isSearchable={false}
      isDisabled={disabled}
      getSelectedValueLabel={(value: { text: string }) => {
        return value.text;
      }}
      onChange={onChange}
      inputGroup={inputGroup}
    />
  );
};

export const OperatorsSelect = React.memo(
  OperatorsSelectUnwrapped,
  (prev, next) =>
    !(
      !_.isEqual(prev.value, next.value) ||
      !_.isEqual(prev.operators, next.operators) ||
      prev.disabled !== next.disabled ||
      prev.extraClassNames !== next.extraClassNames ||
      prev.xstyle !== next.xstyle ||
      prev.inputGroup !== next.inputGroup
    ),
);

const styles = stylex.create({
  operatorSymbol: {
    display: 'inline-block',
    textAlign: 'center',
    fontWeight: 'bolder',
    fontFamily: 'var(--font-family-monospace)',
    width: 25,
  },
  operatorDescription: { paddingLeft: '0.3125rem' },
  operatorSelect: { width: 60 },
});
